import { type ReactNode } from 'react';
import { CropModal } from '@/components/upload/crop-modal';
import { Actions, PickArea } from './verification-photo-bar-parts';
import { useBar, type Wired } from './verification-photo-bar-state';

type Props = { memberId: string; onClose: () => void };

const BAR = 'space-y-sm border-t border-white/[0.06] pt-base';

function HiddenInput({ w }: { w: Wired }): ReactNode {
  return (
    <input
      ref={w.inputRef}
      type="file"
      accept="image/*"
      className="hidden"
      onChange={w.onPicked}
    />
  );
}

function ActionRow({ w }: { w: Wired }): ReactNode {
  return (
    <Actions
      onConfirm={w.onConfirm}
      onCancel={w.onClose}
      disabled={!w.state.file}
      pending={w.pending}
    />
  );
}

function Body({ w }: { w: Wired }): ReactNode {
  return (
    <>
      <p className="text-xs text-text-secondary">
        Selecciona una nueva foto de verificaci&oacute;n para este miembro.
      </p>
      <PickArea preview={w.state.preview} onPick={w.open} />
      <HiddenInput w={w} />
      <ActionRow w={w} />
      <CropModal
        src={w.cropSrc}
        onCancel={w.onCancelCrop}
        onConfirm={w.onCommitCrop}
      />
    </>
  );
}

export function VerificationPhotoBar(p: Props): ReactNode {
  const w = useBar(p.memberId, p.onClose);
  return (
    <div className={BAR}>
      <Body w={w} />
    </div>
  );
}
